export default "__VITE_ASSET__b7936c7e__"